<script lang="ts">
export default {
  name: 'ManagementStatistic',
};
</script>

<script setup lang="ts">
import { IsNullOrUndefined } from '@/utilities/Helpers';
import { InfoIcon } from 'lucide-vue-next';
import Tooltip from '@/components/v2/Tooltip.vue';
import Skeleton from '@/components/v2/Skeleton.vue';

defineProps<{
  heading: string;
  subHeading?: string;
  showSkeleton?: boolean;
  value?: string;
  subValue?: string;
  testLabel: string;
  toolTip?: string;
}>();
</script>

<template>
  <div class="statistic">
    <div class="tw:flex tw:flex-row tw:items-center">
      <h3 class="tw:text-center tw:grow export-no-wrap">{{ heading }}</h3>
      <Tooltip v-if="toolTip" :text="toolTip" position="top">
        <InfoIcon :size="16" class="tw:text-gray-400 tw:ml-1 tw:cursor-help" />
      </Tooltip>
    </div>
    <Skeleton v-if="showSkeleton" shape="text" />
    <div class="tw:flex tw:flex-col">
      <div :data-test="testLabel" class="statistic-value secondary--text--dark" v-if="!showSkeleton">{{ value }}</div>
    </div>
    <div v-if="subHeading && !IsNullOrUndefined(subValue)" class="subheading-container">
      <h5 :data-test="`${testLabel}-sub-header`" class="statistic-subheader">{{subHeading}} </h5>
      <div :data-test="`${testLabel}-sub-value`" class="statistic-subvalue secondary--text--dark">{{ subValue ?? '--' }}</div>
    </div>
  </div>
</template>

<style scoped>
.statistic {
  margin: 1rem;
  position: relative;
}

.statistic.dense {
  margin: 0.5rem 1rem;
}

.statistic-value {
  font-size: 1.5em;
  text-align: center;
  font-weight: 700;
}

.statistic h3 {
  font-size: 0.8rem;
  font-weight: 400;
  color: rgb(107 114 128);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.statistic-subvalue {
  display: inline;
  font-size: 0.8rem;
  text-align: center;
}

.statistic-subheader {
  display: inline;
  color: rgb(156 163 175);
  text-transform: uppercase;
  text-align: center;
}

.subheading-container {
  text-align: right;
  position: absolute;
  top: 100%;
  right: 0%;
  min-width: 15em;
}

@media screen and (max-width: 1100px) {
  .statistic-value {
    font-size: 1.2em;
  }

  .statistic h3 {
    font-size: 0.7rem;
  }

  .statistic-subvalue {
    font-size: 0.5rem;
  }
  
  .tooltip {
    transform: scale(0.75)
  }
  
  .statistic {
    margin: 0.75rem;
  }
  
  .statistic.dense {
    margin: 0.3rem .75rem;
  }
}
</style>
